export default __webpack_public_path__ + "static/media/table-manner.f66ebb96.png";